import gql from 'graphql-tag'

const expeditionServiceGetQuery = gql`
  query expeditionServicesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object) {
    expeditionServicesGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "ExpeditionServices", method: "POST", path: "expedition-service/list") {
      results
      paging
    }
  }
`

export default expeditionServiceGetQuery
